/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Payment_Failed_WarningInputs */



/**
* | output |
* | --- |
* | "Your last payment failed. Please update your payment method to avoid service interruption." |
*
* @param {Subscription_Payment_Failed_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const subscription_payment_failed_warning = /** @type {((inputs?: Subscription_Payment_Failed_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Payment_Failed_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre letzte Zahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsmethode, um eine Dienstunterbrechung zu vermeiden.")
	return /** @type {LocalizedString} */ ("Your last payment failed. Please update your payment method to avoid service interruption.")
});